import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';

function initSwiperSlider() {
    if ($('.swiperSlider').length) {
        $('.swiper-container-custom').each(function () {
            const container = $(this);
            const sliderId = container.data('slider-id');
            const swiperElement = container.find('.swiperSlider')[0];

            // eslint-disable-next-line no-new
            new Swiper(swiperElement, {
                modules: [Navigation],
                lazy: true,
                lazyPreloadPrevNext: 1,
                slidesPerView: 2.5,
                slidesPerGroup: 2,
                spaceBetween: 16,
                speed: 700,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    600: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                    1024: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                },
                navigation: {
                    nextEl: `.swiper-button-next-${sliderId}`,
                    prevEl: `.swiper-button-prev-${sliderId}`,
                    addIcons: false,
                },
            });
        });
    }
}

$(function () {
    initSwiperSlider();
});
